var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromptButtonDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8712_1567)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 59.9637,
    height: 60,
    rx: 29.9819,
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.5,
    width: 58.9637,
    height: 59,
    rx: 29.4819,
    stroke: "#4D5154"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8494 53.2748H53.275V56.8494C53.275 59.9848 57.104 61.6423 59.3724 59.3724C61.6423 57.104 59.9848 53.2748 56.8494 53.2748ZM31.1505 51.7016H34.7249V36.2973H31.1505C26.6184 36.2973 24.2564 30.7717 27.5152 27.5141C30.7724 24.2568 36.2981 26.6174 36.2981 31.1512V34.7257H51.7019V31.1512C51.7019 26.6174 57.2274 24.2569 60.4849 27.5141C63.7421 30.7731 61.3816 36.2973 56.8495 36.2973H53.2751V51.7016H56.8495C61.3832 51.7016 63.7436 57.2273 60.4849 60.4848C57.2276 63.7422 51.7019 61.3816 51.7019 56.8494V53.2749H36.2981V56.8494C36.2981 61.3832 30.7726 63.7436 27.5152 60.4848C24.2564 57.2275 26.6169 51.7016 31.1505 51.7016ZM34.7249 53.2748H31.1505C28.0151 53.2748 26.3577 57.104 28.6275 59.3724C30.8958 61.6424 34.7248 59.9848 34.7248 56.8493L34.7233 53.2748L34.7249 53.2748ZM31.1505 34.7242H34.7249V31.1497C34.7249 28.0126 30.8958 26.3567 28.6275 28.6266C26.3576 30.895 28.0135 34.7242 31.1505 34.7242ZM53.2748 34.7242H56.8492C59.9846 34.7242 61.642 30.895 59.3722 28.6266C57.1038 26.3566 53.2748 28.0142 53.2748 31.1497L53.2748 34.7242ZM51.7016 36.2974H36.2978V51.7017H51.7016V36.2974Z",
    fill: "#3D7AB4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8712_1567",
    x: 0,
    y: 0,
    width: 87.9639,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8712_1567"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8712_1567",
    result: "effect2_dropShadow_8712_1567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8712_1567",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptButtonDark);
export default __webpack_public_path__ + "static/media/promptButtonDark.26549197484df1e2ea0e564ae56b7fb4.svg";
export { ForwardRef as ReactComponent };